module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "abt"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img01_1-3.png"
    }
  }), _c('br'), _vm._v("ABOUT THE AUTHOR")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jerry Jones is a well-respected, nationally known speaker. He has shared his message of hope with hundreds of audiences across the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Jones holds master’s degrees in religious education and theology and a doctor’s degree in theology. He has served as a minister in several states and in six foreign countries. He has taught classes on the undergraduate and graduate level.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was married to Claudette DuBois for thirty-five years before she died after a lengthy battle with cancer. He is now married to Lynn Thompson. Together, they have a blended family of three sons and two daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Jones has written eleven books and currently spends his time ministering, counseling, and writing."), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Beyond the STORM")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Finding God’s Calm Assurance")]), _vm._v(" "), _c('p', {
    staticClass: "bauthor"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R.")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERRY")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONES")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("HOWARD"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PUBLISHING CO.")]), _c('br'), _vm._v("West Monroe, Louisiana")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Our purpose at Howard Publishing is to:")])]), _c('ul', [_c('li', [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Increase faith")]), _vm._v(" in the hearts of growing Christians")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Inspire holinesss")]), _vm._v(" in the lives of believers")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Instill hope")]), _vm._v(" in the hearts of struggling people everywhere")])])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('strong', [_vm._v("Because He’s coming again!")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1",
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("Beyond the Storm")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 1997 by Howard Publishing Co., Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. Printed in the United States of America")])]), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Published by Howard Publishing Co., Inc.,"), _c('br'), _vm._v("3117 North 7th Street, West Monroe, LA 71291-2227"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Third printing 2002")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("No part of this publication may be reproduced in any form without the prior written permission of the publisher except in the case of brief quotations within critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Jones, Jerry, 1938-")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond the storm : finding God’s calm assurance / Jerry Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("ISBN 1-58229-295-7 (pbk.)"), _c('br'), _vm._v("ISBN 978-1-451-60503-7")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1. Consolation. 2. Encouragement—Religious aspects—Christianity. 3. Hope—Religious aspects—Christianity. 4. Faith. 5. Despair—Religious aspects—Christianity. 6. Loss (Psychology)—Religious aspects—Christianity. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("BV4905.2.J654 1997")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("248.8′6—dc21   97-7902")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("CIP")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Jacket Design by LinDee Loveland")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Edited by Philis Boultinghouse")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“More Than Conquerors” © 1978 Birdwing Music BMG Songs, Inc. & Mighty Wind Music. Admin. by EMI Christian Music Publishing. Used by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Scripture quotations not otherwise marked are from the New International Version, © 1973, 1978, 1984 by International Bible Society. Used by permission Zondervan Bible Publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All italics in Scripture were added by the author for emphasis."), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362cdfb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002.vue
// module id = 66
// module chunks = 0